const EventEmitter = require('events').EventEmitter
var moment = require('moment')
moment.locale('it')
import axios from './tAxios'
import dbItem from './dbItem'


class abstract{
   constructor (args) {
      this.event = new EventEmitter()
      this.moment = moment

      this.profile = new dbItem({database:'esphm_abstract_2025',table:'abstract'})
      this.abstract = new dbItem({table:'abstract'})

      this.profile.event.on('loaded', async () =>{
         console.log("CARICO ABSTRACT")
         console.log(this.profile.row)

         if(this.profile.row.revisore_proposto == 0)
            this.profile.row.revisore_proposto = ''


         await this.init() 
      })

      //this._topic = []
      this._autore = []
      this.abstractCerca=''
      this.autoreCerca=''
      return this
   }
   /*
   async getTopics(){
      axios.query('fetchAll',`SELECT * FROM topic WHERE evento=←evento ORDER BY peso, nome`,{evento: this.profile.row.evento},this,'_topic')
      return new Promise((resolve, reject) => {resolve("Fatto")})
   }
   */
   async getAutori(){
      return new Promise((resolve, reject) => {
         if(this.profile.row.id>0){
            axios.query('fetchAll',`SELECT absautore.*, autore.cognome, autore.nome, autore.affiliazione FROM abstract_autore AS absautore LEFT JOIN autore ON autore.id=absautore.autore AND absautore.abstract=←id WHERE absautore.abstract=→id  ORDER BY absautore.numero, autore.cognome, autore.nome`,{id: this.profile.row.id},this,'_autore').then(rensponse => {
               console.log("AUTORI OLD ARE "+this.profile.row.autoricount+' BUT NUW ARE '+this._autore.length)
               if(this.profile.row.autoricount != this._autore.length){
                  this.profile.row.autoricount = this._autore.length
                  this.profile.save()
               }
               resolve({result:true,message:'trovati '+this._autore.length+'autori'})
            
            }).catch(error=>{reject(error)})
         }else{
            resolve({result:true,message:'nessun autore'})
         }
      })
   }

   async resetPreview(){
      this.profile.row.previewil = '0000-00-00 00:00:00'
      this.profile.row.preview = ''
      await this.profile.save()
      return new Promise((resolve, reject) => {resolve("Fatto")})
   }
   
   async init(){
      //await this.getTopics()
      await this.getAutori()

      return new Promise((resolve, reject) => {
         console.log("INIT finito per "+this.profile.row.titolo)
         resolve("Fatto")
      })
   }



}
export default new abstract
